import { ICallTrackingActivity } from '@user/features/CampaignTracking/typings'
import { ServiceConfig } from '@user/store/services/config'
import { post } from '@user/store/services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.integrations.callTracking}/searchCaller`

export const getCallActivityByPhone = async (
  phoneNumber: string,
): Promise<ICallTrackingActivity | null> => {
  if (phoneNumber && phoneNumber.length >= 10) {
    try {
      const response = await post(`${baseUrl}`, { phoneNumber: phoneNumber })

      if (response.ok) {
        const callTrackingActivity: ICallTrackingActivity =
          await response.json()
        return callTrackingActivity
      }
    } catch {
      return null
    }
  }
  return null
}
